import * as React from 'react';

import UserAssignmentSvg from '../assets/user-assignment.svg';

import styles from './help-graphic-user-assignment.module.css';

export class HelpGraphicUserAssignment extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles['user-assignment']}>
                <UserAssignmentSvg />
            </div>
        );
    }
}
